import { isEmpty } from "lodash";
import moment from "moment";
import {
  CUSTOM_FIELD_FILTER_KEY,
  FILTER_KEYS,
  OPERATOR_KEYS,
} from "../../constants/conversationFilter";
import {
  CUSTOM_FIELD_PREFIX,
  TAGS_OPERATOR_KEY,
  WIHTOUT_TAGS_OPERATOR_KEY,
} from "./reducer";

export const getTagsOperatorsState = ({ filtersState }) => {
  const {
    [TAGS_OPERATOR_KEY]: tagsOperator,
    [WIHTOUT_TAGS_OPERATOR_KEY]: withoutTagsOperator,
    [FILTER_KEYS.TAGS_FILTER]: tagsFilter = {},
    [FILTER_KEYS.WITHOUT_TAGS_FILTER]: withoutTagsFilter = {},
  } = filtersState;

  const { values: tagsValues = [] } = tagsFilter;
  const { values: wihtoutTagsValues = [] } = withoutTagsFilter;

  const isTagsSelected = tagsValues.length > 0;
  const isWithoutTagsSelected = wihtoutTagsValues.length > 0;

  const disableTagsOperator =
    withoutTagsOperator === OPERATOR_KEYS.ALL && isWithoutTagsSelected;

  const disableWithoutTagsOperator =
    tagsOperator === OPERATOR_KEYS.ALL && isTagsSelected;

  const isAnyAllCombinationOperationSelected =
    isTagsSelected &&
    isWithoutTagsSelected &&
    (tagsOperator === OPERATOR_KEYS.ALL ||
      withoutTagsOperator === OPERATOR_KEYS.ALL);

  return {
    disableTagsOperator,
    disableWithoutTagsOperator,
    isAnyAllCombinationOperationSelected,
    tagsOperator,
    withoutTagsOperator,
  };
};

const generateFiltersPayload = (filtersState) => {
  const payload = [];
  for (const [filterKey, filterData] of Object.entries(filtersState)) {
    const isCustomFieldFilter = filterKey.startsWith(CUSTOM_FIELD_PREFIX);
    if (
      !(Object.values(FILTER_KEYS).includes(filterKey) || isCustomFieldFilter)
    )
      continue;

    const { values, op, custom_field_id } = filterData;

    if (isEmpty(values)) continue;

    const payloadObj = { name: filterKey, op, values };
    if (isCustomFieldFilter) {
      payloadObj.custom_field_id = custom_field_id;
      payloadObj.name = CUSTOM_FIELD_FILTER_KEY;
    }
    if (filterKey === FILTER_KEYS.TAGS_FILTER) {
      payloadObj.op = filtersState[TAGS_OPERATOR_KEY];
    }
    if (filterKey === FILTER_KEYS.WITHOUT_TAGS_FILTER) {
      payloadObj.op = filtersState[WIHTOUT_TAGS_OPERATOR_KEY];
    }
    payload.push(payloadObj);
  }

  return payload;
};

export const getDefaultSmCoversationsPayload = () => {
  const to_date = moment().format("YYYY-MM-DD");
  const from_date = moment(to_date).subtract(30, "days").format("YYYY-MM-DD");
  return {
    from_date,
    to_date,
    is_bh: false,
    timezone: "UTC",
    timezone_offset: 0,
    sort_by: {
      field: "event_at",
      order: "desc",
    },
    pagination: {
      page: 1,
      limit: 10,
      total: 0,
    },
  };
};

export const generateSmCoversationsPayload = ({ filtersState }) => {
  const defaultPayload = getDefaultSmCoversationsPayload();
  const filterPayload = generateFiltersPayload(filtersState);
  const payload = { ...defaultPayload };
  if (Array.isArray(filterPayload) && filterPayload.length > 0) {
    payload.filter_by = filterPayload;
  }
  return payload;
};

const FILTER_GUIDER_LOCAL_KEY = "comversation_filter_guider_seen";

export const getFilterGuiderLocalKey = () => {
  return window.localStorage.getItem(FILTER_GUIDER_LOCAL_KEY) === "true";
}

export const setFilterGuiderLocalKey = () => {
  return window.localStorage.setItem(FILTER_GUIDER_LOCAL_KEY, "true");
}